import React from "react";
import { Image } from "lucide-react";
import type { GeneratedSlides, ColorScheme } from "../types";
import { getSlideColor } from "../utils";

interface ResourcesSectionProps {
  generatedSlides: GeneratedSlides;
  colorScheme: ColorScheme;
}

export const ResourcesSection: React.FC<ResourcesSectionProps> = ({
  generatedSlides,
  colorScheme,
}) => {
  const primaryColor = getSlideColor(colorScheme);

  if (!generatedSlides?.visualResources?.length) return null;

  return (
    <div>
      <h4 className="font-bold mb-3 flex items-center gap-2 text-(--text-primary)">
        <Image className="w-5 h-5" />
        Recursos Visuais Sugeridos
      </h4>
      <div className="space-y-2">
        {generatedSlides.visualResources.map((resource, index) => (
          <div
            key={index}
            className="flex items-center gap-3 p-3 rounded-lg border border-(--border-color) bg-(--bg-accent)"
          >
            <div
              className="w-2 h-2 rounded-full"
              style={{ backgroundColor: primaryColor }}
            ></div>
            <span className="text-(--text-secondary)">{resource}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
